var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"accessibility-focus",rawName:"v-accessibility-focus",value:(_vm.choose),expression:"choose"}],staticClass:"o-radiobutton"},[_c('i',{staticClass:"o-radiobutton__icon o-icon",class:[_vm.isChosen ? 'o-icon--radiobox-marked' : 'o-icon--radiobox-blank']}),_c('div',{staticClass:"o-radiobutton__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }